/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * The resource used in Problem schemas. Doesn't have data field.
 */
export interface Resource {
    annotations: Record<string, string>;
    /** Timestamp string according to [RFC 3339](https://www.rfc-editor.org/rfc/rfc3339). */
    createdAt: Date;
    /** Timestamp string according to [RFC 3339](https://www.rfc-editor.org/rfc/rfc3339). */
    deletedAt?: Date;
    /**
     * The general purpose ETag.
     * The essential field for **optimistic concurrency**.
     * - [Zalando RESTful Guidelines / Appendix C: Best practices / ETags in result entities](https://opensource.zalando.com/restful-api-guidelines/#ETag-in-result-entities)
     * - [RFC 9110 - 8.8.3 ETag](https://www.rfc-editor.org/rfc/rfc9110.html#name-ETag)
     * - [RFC 9110 - 13.1.1. IfMatch](https://www.rfc-editor.org/rfc/rfc9110.html#name-if-match)
     * - [RFC 9110 - 13.1.2. IfNoneMatch](https://www.rfc-editor.org/rfc/rfc9110.html#name-if-none-match)
     * - [Kubernetes' Concurrency Control and Consistency](https://github.com/kubernetes/community/blob/master/contributors/devel/sig-architecture/api-conventions.md#concurrency-control-and-consistency).
     */
    etag: string;
    /**
     * The primary and unique identifier of the resource (inside tenant)
     * according to [RFC 4122](https://www.rfc-editor.org/info/rfc4122).
     */
    id: string;
    kind: string;
    labels: Record<string, string>;
    /** Timestamp string according to [RFC 3339](https://www.rfc-editor.org/rfc/rfc3339). */
    modifiedAt: Date;
    /** Similar to kubernetes `resourceVersion` and `generation` field to identify the object version. */
    revision: number;
}
